import Revolugo from '../primevue/themes/revolugo/index.ts'

import type { PrimeVueConfiguration } from 'primevue/config'

export { default as PrimeVue } from 'primevue/config'

export const PRIME_CONFIG: PrimeVueConfiguration = {
  pt: Revolugo,
  theme: 'none',
  unstyled: true,
  zIndex: {
    overlay: 3000,
  },
}
